module.exports = __webpack_public_path__ + "static/media/km.5946bdc7.svg";